import { render, staticRenderFns } from "./bkPolicyAndCustomerBirthCheck.vue?vue&type=template&id=00c820f4&scoped=true"
import script from "./bkPolicyAndCustomerBirthCheck.vue?vue&type=script&lang=js"
export * from "./bkPolicyAndCustomerBirthCheck.vue?vue&type=script&lang=js"
import style0 from "./bkPolicyAndCustomerBirthCheck.vue?vue&type=style&index=0&id=00c820f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c820f4",
  null
  
)

export default component.exports